import { NAVIGATE } from './types';

export const navigate = (path) => ({
  type: NAVIGATE,
  payload: path,
});
